"use client";

import { useEffect, useState } from "react";

import { formatRelativeTime } from "./date-format";

export function RelativeTime({ value }: { value: string }) {
  const [label, setLabel] = useState("recently");

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setLabel(formatRelativeTime(value));
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [value]);

  return label;
}
